// 配列を定義
export const RelaxedRuleValues = [
  '労働時間',
  '指定時間',
  '重量',
  '体積',
  '数量',
  '指定車両タイプ',
  '指定車種',
  '荷台高さ',
  '荷台幅',
  '荷台長さ',
  '床仕様',
  '装置',
  '積み合わせ',
  '指定トラック',
  'NGドライバー',
  '最大回転数',
  '1回転あたりの最大納品先件数',
  'エリア配車',
  '集配区分',
  '配送バンドルID',
  '大型車両と荷物の割り付け条件',
] as const;

// 配列から型を生成
export type RelaxedRuleVo = typeof RelaxedRuleValues[number];
